import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';

import { ReactSelectOption } from '../Selects/SortableSelect';
import FormRow from '../../../app/components/FormRow';
import { CreateUpdateUserDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { RoleText } from '../../../common/spdCore/authorization/roles';
import DynamicTextarea from '../../../app/components/DynamicTextarea';
import HealthcareFacilitiesMultiSelector from '../HealthcareFacility/HealthcareFacilitiesMultiSelector';

interface UserEditorTabDataProps {
  id?: string;
  user: CreateUpdateUserDto | undefined;
  adminReadOnly: boolean;
  healthCareFacilities: ReactSelectOption[];
  propertyChange: (obj: Partial<CreateUpdateUserDto>) => void;
  handleChangeHF: (tempHfs: ReactSelectOption[]) => void;
}

const getAllRoles = () =>
  Object.keys(RoleText).map(name => ({
    value: name,
    label: RoleText[name as keyof typeof RoleText],
  }));

export const UserEditorTabData: React.FC<UserEditorTabDataProps> = ({
  id,
  user,
  adminReadOnly,
  healthCareFacilities,
  propertyChange,
  handleChangeHF,
}) => {
  const selectedRoles = getAllRoles().filter(item =>
    user?.roles?.includes(item.value),
  );

  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="user_name" label="Imię i nazwisko">
        <Form.Control
          type="text"
          value={user?.name || ''}
          onChange={e => propertyChange({ name: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="user_email" label="Adres e-mail">
        <Form.Control
          type="email"
          value={user?.email || ''}
          onChange={e => propertyChange({ email: e.target.value })}
          readOnly={id ? true : false}
        />
      </FormRow>
      <FormRow controlId="description" label="Opis">
        <DynamicTextarea
          value={user?.description || ''}
          onChange={e => propertyChange({ description: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="examined" label="Rola">
        <Select
          options={getAllRoles()}
          value={selectedRoles}
          isMulti
          className="test-multi-select"
          classNamePrefix="driving-select"
          onChange={options =>
            propertyChange({ roles: options.map(o => o.value) })
          }
          placeholder="Wskaż..."
        />
      </FormRow>
      <FormRow controlId="healthcareFacilities" label="Widoczne placówki">
        <HealthcareFacilitiesMultiSelector
          selectedHealthcareFacility={healthCareFacilities}
          canSeeAll={true}
          onChange={options => handleChangeHF((options || []).map(o => o))}
        />
      </FormRow>
      <FormRow controlId="user_admin" label="Administrator">
        <Form.Check
          type="checkbox"
          checked={user?.admin ? true : false}
          onChange={e => propertyChange({ admin: e.target.checked })}
          disabled={adminReadOnly}
        />
      </FormRow>
      <FormRow controlId="user_active" label="Aktywny">
        <Form.Check
          type="checkbox"
          checked={user?.active ? true : false}
          onChange={e => propertyChange({ active: e.target.checked })}
        />
      </FormRow>
    </Form>
  );
};
